/** @format */

import { Popin, colorPalette } from "@ui-library/core"
import styled from "styled-components"

export const StyledPopin = styled(Popin)`
	z-index: 10001;
	.content-wrapper {
		padding: 0px 0px 0px 0px;
	}

	div[role="dialog"] {
		width: 580px;
	}

	section {
		outline: none;
	}
`

export const Body = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	padding: 0px 32px 48px;
	position: relative;

	.title {
		align-self: stretch;
		color: ${colorPalette.greyDark}
		font-family: "Source Sans Pro";
		font-size: 24px;
		font-style: normal;
		font-weight: 700;
		line-height: 30px;
		text-align: center;
		margin: 0;
	}

	.text-wrapper {
		margin-top: 0.5em;
		margin-bottom: 2em;
		font-size: 16px;
		text-align: center;
	}
`
